export class ItemLifecycleFactory {
    static create(itemLifecycle: IContentAPIItemLifecycle): IContentAPIItemLifecycle {
        return new ItemLifecycle(itemLifecycle).serialize();
    }
}

export class ItemLifecycle {
    protected _status: ItemLifecycleStatus;
    protected _itemReplacementRef?: string;

    constructor(itemLifecycle: IContentAPIItemLifecycle) {
        this._status = itemLifecycle.status;
        this._itemReplacementRef = itemLifecycle.itemReplacementRef;
    }

    serialize(): IContentAPIItemLifecycle {
        return {
            status: this._status,
            itemReplacementRef: this._itemReplacementRef
        };
    }
}

export interface IContentAPIItemLifecycle {
    status: ItemLifecycleStatus;
    itemReplacementRef?: string;
}